var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.$root.user.active
      ? _c(
          "div",
          [
            _vm._m(0),
            _vm._v(" "),
            _vm._l(_vm.subscriptions, function(subscription, index) {
              return _c("div", [
                index == 1
                  ? _c("div", { staticClass: "row head" }, [
                      _c("div", { staticClass: "col col-100" }, [
                        _vm._v("Nieuwe abonnement")
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                index == 0 &&
                _vm.$root.app.platform == "ios" &&
                subscription.swappable
                  ? _c(
                      "div",
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to:
                                "/subscription/" + subscription.id + "/options"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "row setting subscription",
                                class: {
                                  "row-single":
                                    _vm.subscriptions.length - 1 === index
                                }
                              },
                              [
                                _c("div", {
                                  staticClass: "avatar",
                                  class: "avatar--" + subscription.icon
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "account-info col" }, [
                                  _c("div", { staticClass: "table" }, [
                                    _c("div", { staticClass: "cell" }, [
                                      _c(
                                        "div",
                                        { staticClass: "account-info__title" },
                                        [_vm._v(_vm._s(subscription.name))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "account-info__subtitle"
                                        },
                                        [
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(subscription.description)
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("p", [
                                            _c("em", [
                                              _vm._v(
                                                _vm._s(subscription.salesLine1)
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "account-info__subtitle--large"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(subscription.price) +
                                                  " exclusief btw p/m"
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      subscription.status == "cancelled"
                                        ? _c(
                                            "p",
                                            { staticClass: "info info--2" },
                                            [
                                              _c("i", {
                                                staticClass: "icon icon-close"
                                              }),
                                              _vm._v(
                                                "Verloopt op " +
                                                  _vm._s(
                                                    subscription.expireTime
                                                  ) +
                                                  "\n                                    "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ])
                                  ])
                                ])
                              ]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _c("div", [
                      _c(
                        "div",
                        {
                          staticClass: "row has-subitem setting subscription",
                          class: {
                            "row-last": _vm.subscriptions.length - 1 === index
                          }
                        },
                        [
                          _c("div", {
                            staticClass: "avatar",
                            class: "avatar--" + subscription.icon
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "account-info" }, [
                            _c("div", { staticClass: "table" }, [
                              _c("div", { staticClass: "cell" }, [
                                _c(
                                  "div",
                                  { staticClass: "account-info__title" },
                                  [_vm._v(_vm._s(subscription.name))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "account-info__subtitle" },
                                  [
                                    _c("p", [
                                      _vm._v(_vm._s(subscription.description))
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _c("em", [
                                        _vm._v(_vm._s(subscription.salesLine1))
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "account-info__subtitle--large"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(subscription.price) +
                                            " exclusief btw p/m"
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                subscription.swappable == false &&
                                subscription.status == "active"
                                  ? _c("div", [
                                      _c("p", { staticClass: "info info--1" }, [
                                        _c("i", {
                                          staticClass: "icon icon-clock"
                                        }),
                                        _vm._v(
                                          "Gaat in op " +
                                            _vm._s(subscription.startTime)
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("p", { staticClass: "info info--4" }, [
                                        _c("i", {
                                          staticClass: "icon icon-exclamation"
                                        }),
                                        _vm._v(
                                          "Je kunt over " +
                                            _vm._s(subscription.swapCooldown) +
                                            " dagen weer wijzigen"
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                subscription.status == "cancelled"
                                  ? _c("p", { staticClass: "info info--2" }, [
                                      _c("i", {
                                        staticClass: "icon icon-close"
                                      }),
                                      _vm._v(
                                        "Verloopt op " +
                                          _vm._s(subscription.expireTime) +
                                          "\n                                "
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            ])
                          ])
                        ]
                      )
                    ]),
                _vm._v(" "),
                subscription.status == "cancelled" &&
                _vm.subscriptions.length == 1
                  ? _c("div", [
                      _c("div", { staticClass: "row spacer" }, [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row row-button" }, [
                        _c("div", { staticClass: "col col-100" }, [
                          _c(
                            "button",
                            {
                              staticClass: "button button--alt",
                              on: {
                                click: function($event) {
                                  return _vm.reactivate_subscription(
                                    subscription.id
                                  )
                                }
                              }
                            },
                            [_vm._v("Abonnement heractiveren")]
                          )
                        ])
                      ])
                    ])
                  : _c(
                      "div",
                      [
                        subscription.swappable
                          ? _c(
                              "router-link",
                              {
                                attrs: {
                                  to:
                                    "/subscription/" +
                                    subscription.id +
                                    "/options"
                                }
                              },
                              [
                                _c("div", { staticClass: "row spacer" }, [
                                  _vm._v(" ")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "row row-button has-subitem" },
                                  [
                                    _c("div", { staticClass: "col col-100" }, [
                                      _c(
                                        "button",
                                        { staticClass: "button button--alt" },
                                        [_vm._v("Abonnement wijzigen")]
                                      )
                                    ])
                                  ]
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "row spacer" }, [_vm._v(" ")]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "row row-button row-button--bottom" },
                          [
                            _c("div", { staticClass: "col col-100" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "button",
                                  on: {
                                    click: function($event) {
                                      return _vm.cancel_subscription(
                                        subscription.id
                                      )
                                    }
                                  }
                                },
                                [_vm._v("Abonnement opzeggen")]
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    )
              ])
            })
          ],
          2
        )
      : _c("div", [_vm._m(1)]),
    _vm._v(" "),
    _vm.$root.app.platform == "ios"
      ? _c("div", { staticClass: "row spacer" }, [_vm._v(" ")])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row head" }, [
      _c("div", { staticClass: "col col-100" }, [_vm._v("Huidig abonnement")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row setting explanation notice" }, [
      _c("div", { staticClass: "col col-100" }, [
        _c("b", [_vm._v("Inactief account")]),
        _c("br"),
        _vm._v("\n                Uw abonnement is verlopen. "),
        _c("br"),
        _vm._v(
          "Wilt u een nieuw abonnement? Neem dan contact op met onze helpdesk via 'Ondersteuning'.\n            "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e073814", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e073814","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subscriptions.vue
// module id = null
// module chunks = 